module.exports = __webpack_public_path__ + "img/6.2.TN.b8c67ccb.png";